// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2ciPD","footer":"ChangeClinic_footer__2R1ME"};